import Grid from "react-bootstrap/es/Grid";
import { default as Row } from './Row';
import { default as Col } from './Col';
import { default as Clearfix } from './Clearfix';
Grid.Row = Row;
Grid.Col = Col;
Grid.Clearfix = Clearfix;
export default Grid;